export default "__VITE_ASSET__C_0G7Bj4__"